<template>
  <div>
    <notifications></notifications>
    <div slot="brand" class="navbar-wrapper pt-3">
      <a
        href="https://misepis.com/"
        class="nav-link"
        target="_blank"
        rel="noopener"
      >
        <img
          src="/img/brand/logo_basic_murrey.png"
          style="height: 70px !important; display: block; margin: auto"
        />
      </a>
    </div>

    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>

    <!--  <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div> -->

    <footer class="py-4" id="footer-main">
      <div class="container">
        <div class="row justify-content-xl-between">
          <!-- <div class="col-xl-6">
            <ul class="nav nav-footer ">
              <li class="nav-item">
                <a href="" class="nav-link" target="_blank" rel="noopener"
                  >Uso legal</a
                >
              </li>

              <li class="nav-item">
                <a href="" class="nav-link" target="_blank" rel="noopener"
                  >Política de privacidad</a
                >
              </li>
              <li class="nav-item">
                <a href="" class="nav-link" target="_blank" rel="noopener"
                  >Cookies</a
                >
              </li>
            </ul>
          </div> -->
          <div class="col-xl">
            <div class="copyright text-center text-muted">
              <a
                href="https://www.salvadorvertical.com/"
                target="_blank"
                rel="noopener"
              >
                ©{{ year }} Salvador Seguridad En Altura SL</a
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        //  this.updateBackground();
      },
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
